module.exports = __webpack_public_path__ + "static/media/02C.6bf1a0df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/02C.png
// module id = 277
// module chunks = 0